import React from 'react'
import moment from 'moment'
import { ImportStatus } from '@driftt/crm-components'

const getColumns = () => [
  {
    label: 'Name'
  },
  {
    label: 'Sync status'
  },
  {
    label: 'Type'
  },
  {
    label: 'Created'
  },
]

const getRow = ({ list }) => {
  return [
    {
      content: list.displayName
    },
    {
      content: <ImportStatus status={list.status} />
    },
    {
      content: list.type === 'SMART' ? 'Smart list ⚡️' : 'Static list'
    },
    {
      content: moment(list.marketoCreatedAt).fromNow()
    },
  ]
}

export default { getRow, getColumns }
